import axios from 'axios'
import authInterceptor from '@/apis/interceptors/auth'
import resCodeInterceptor from '@/apis/interceptors/res-code'

export default resCodeInterceptor(authInterceptor(axios.create()))



// WEBPACK FOOTER //
// ./src/apis/admin-api/client.js